<h4>Términos y condiciones del Pago en Línea</h4>

<p>
  Transacción protegida por BBVA (Openpay es una empresa de BBVA)
</p>
<p>
  Al pagar utilizando esta herramienta el colegiado declara haber aceptado los Términos y 
  Condiciones que estén vigentes al momento de acceso y pago.
</p>
<hr>
<h4 class="alert-heading">Políticas de devoluciones y cancelaciones</h4>
<ul>
  <li>
    Es importante que el colegiado esté seguro del concepto a pagar, ya que no habrá reembolsos 
    ni devoluciones por el importe pagado.
  </li>
  <li>
    Cualquier solicitud de reclamación o aclaración sobre algún concepto que haya sido pagado, debe ser 
    notificado al Colegio de Arquitectos Tabasqueños A.C. por el colegiado proporcionando el folio 
    generado del pago realizado para su verificación. Sin el folio de pago, no se aceptarán reclamos ni
    aclaraciones.
  </li>
  <li>
    Sólo habrá devoluciones y cancelaciones del monto pagado por algún concepto siempre y cuando sea 
    una situación extraordinaria y que haya sido aprobado y autorizado por el Colegio de Arquitectos 
    Tabasqueños A.C.
  </li>
 </ul>
<h4 class="alert-heading">Políticas de Seguridad</h4>
<ul>
  <li>
    Como parte del proceso de pago de un producto/servicio a través de https://www.arquitab.org.mx, 
    el colegiado acuerda la provisión de los detalles de su tarjeta de débito/crédito, por lo que 
    comprende, entiende y confirma que los detalles de la tarjeta de débito/crédito provistos son 
    correctos y declara que es el titular de dicha tarjeta y no hace uso de una tarjeta 
    de débito/crédito obtenida de manera ilegal.
  </li>
  <li>              
    El Colegio de Arquitectos Tabasqueños A.C. podrá solicitarle al cliente la presentación en físico 
    de la tarjeta de débito/crédito que se utilice para el proceso de pago en línea, así como una 
    identificación del titular de dicha tarjeta, con el fin de corroborar los datos del pago o realizar 
    aclaraciones, si así fuese necesario.
  </li>
  <li>
    Las tarjetas de débito/crédito son procesadas por el sistema de pagos Openpay, de tal manera que 
    el Colegio de Arquitectos Tabasqueños A.C. no maneja ni almacena la información de las mismas.
  </li>
</ul>